
// Global add-to-cart function for pack validate buttons
function addPackToCart(packNum, selectorPrefix) {
  var prefix = selectorPrefix || '.cc-pack';
  var pack = document.querySelector(prefix + '[data-pack="' + packNum + '"]');
  if (!pack) return;

  var sizeSelect = pack.querySelector('.cc-pack__size-select');
  if (!sizeSelect || !sizeSelect.value) {
    if (sizeSelect) {
      sizeSelect.style.borderColor = '#FF5A1E';
      sizeSelect.focus();
      setTimeout(function() { sizeSelect.style.borderColor = ''; }, 2000);
    }
    return;
  }

  var btn = pack.querySelector('.cc-pack__validate-cta[data-pack="' + packNum + '"]') || pack.querySelector('.cc-pack__validate-cta');

  var variantId = parseInt(sizeSelect.value);
  if (isNaN(variantId)) {
    sizeSelect.style.borderColor = '#FF2E7E';
    sizeSelect.focus();
    return;
  }
  if (btn) { btn.style.opacity = '0.6'; btn.style.pointerEvents = 'none'; }
  var sizeName = sizeSelect.options[sizeSelect.selectedIndex].textContent.trim();
  var items = [{ id: variantId, quantity: 1 }];

  var subEl = document.querySelector('[id^="cc-sub-products-"]') || document.querySelector('[id^="cc-cta-sub-products"]');
  if (subEl) {
    try {
      var allSub = JSON.parse(subEl.textContent);
      var pd = allSub['pack_' + packNum];
      if (pd && pd.products && pd.products.length > 1) {
        pd.products.slice(1).forEach(function(prod) {
          var sizeEq = { 'XS': 'S', 'XXL': '2XL', '2XL': 'XXL' };
          var m = prod.variants.find(function(v) { return v.option1 === sizeName && v.available; });
          if (!m && sizeEq[sizeName]) {
            m = prod.variants.find(function(v) { return v.option1 === sizeEq[sizeName] && v.available; });
          }
          var f = prod.variants.find(function(v) { return v.available; });
          var vid = m ? m.id : (f ? f.id : null);
          if (vid) items.push({ id: vid, quantity: 1 });
        });
      }
    } catch(e) { console.warn(e); }
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (btn) { btn.style.opacity = '1'; btn.style.pointerEvents = ''; }
    var cartDrawer = document.querySelector('cart-drawer[data-section-id]');
    var sectionId = cartDrawer ? cartDrawer.dataset.sectionId : 'cart-drawer';
    Promise.all([
      fetch('/?sections=' + sectionId).then(function(r) { return r.json(); }),
      fetch('/cart.js').then(function(r) { return r.json(); })
    ]).then(function(results) {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { data: { itemCount: results[1].item_count, sections: results[0] } }
      }));
      document.dispatchEvent(new CustomEvent('cart:open'));
    }).catch(function() {
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  })
  .catch(function(err) {
    console.error(err);
    if (btn) { btn.style.opacity = '1'; btn.style.pointerEvents = ''; }
  });
}

// Auto-bind size change listeners on all pack selects + calculate totals
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cc-pack__size-select').forEach(function(select) {
    select.addEventListener('change', function() {
      var pack = select.closest('.cc-pack') || select.closest('.cc-cta-pack');
      if (!pack) return;
      var opt = select.options[select.selectedIndex];
      var sizeText = (opt && opt.value) ? 'Taille ' + opt.textContent.trim() : '--';

      // Update recap size text
      pack.querySelectorAll('[data-recap-size]').forEach(function(el) {
        el.textContent = sizeText;
      });

      // Calculate total: products only (shipping excluded)
      var total = 0;
      pack.querySelectorAll('.cc-pack__recap-lines .cc-pack__recap-line-price').forEach(function(el) {
        if (el.closest('.cc-pack__recap-line--bonus')) return;
        if (el.closest('.cc-pack__recap-line--shipping')) return;
        var text = el.textContent.trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
        var val = parseFloat(text);
        if (!isNaN(val)) total += val;
      });

      // Format
      var formatted = total.toFixed(2).replace('.', ',') + ' \u20ac';

      // Update Total
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = formatted;

      // Update CTA button price
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    });
  });

  // Calculate totals on page load for all packs (not just on size change)
  function calculatePackTotal(pack) {
    // Use bundle price from data attribute if available (set by theme editor)
    var bundlePrice = pack.dataset ? pack.dataset.bundlePrice : null;
    if (bundlePrice && bundlePrice.trim()) {
      // Bundle price is pre-set from settings, use it directly for total and CTA
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = bundlePrice.trim();
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = bundlePrice.trim();
      return;
    }
    // Fallback: sum product prices only (shipping excluded)
    var total = 0;
    pack.querySelectorAll('.cc-pack__recap-lines .cc-pack__recap-line-price').forEach(function(el) {
      if (el.closest('.cc-pack__recap-line--bonus')) return;
      if (el.closest('.cc-pack__recap-line--shipping')) return;
      var text = el.textContent.trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
      var val = parseFloat(text);
      if (!isNaN(val)) total += val;
    });
    if (total > 0) {
      var formatted = total.toFixed(2).replace('.', ',') + ' \u20ac';
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = formatted;
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    }
  }

  // Run on load for all packs
  document.querySelectorAll('.cc-pack, .cc-cta-pack').forEach(calculatePackTotal);
});


/* ============================================
   CONCOURS HARLEY-DAVIDSON - JS
   ============================================ */

/* --- Countdown Timer --- */
class ConcoursCountdown extends HTMLElement {
  connectedCallback() {
    const end = this.getAttribute('data-end');
    const start = this.getAttribute('data-start');
    if (!end) return;

    const endDate = new Date(end);
    const startDate = start ? new Date(start) : new Date();

    const update = () => {
      const now = Date.now();
      const diff = endDate - now;

      const el = (sel1, sel2) => this.querySelector(sel1) || this.querySelector(sel2);
      const daysEl = el('[data-days]', '.cc-countdown__value--days');
      const hoursEl = el('[data-hours]', '.cc-countdown__value--hours');
      const minutesEl = el('[data-minutes]', '.cc-countdown__value--minutes');
      const secondsEl = el('[data-seconds]', '.cc-countdown__value--seconds');

      if (diff <= 0) {
        // Loop: restart 5h countdown
        var fiveH = 5 * 60 * 60 * 1000;
        var loopDiff = fiveH - (Math.abs(diff) % fiveH);
        var ld = Math.floor(loopDiff / 86400000);
        var lh = Math.floor((loopDiff % 86400000) / 3600000);
        var lm = Math.floor((loopDiff % 3600000) / 60000);
        var ls = Math.floor((loopDiff % 60000) / 1000);
        if (daysEl) daysEl.textContent = ld;
        if (hoursEl) hoursEl.textContent = String(lh).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(lm).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(ls).padStart(2, '0');
        const expiredText = this.getAttribute('data-expired-text');
        if (expiredText) {
          const label = this.querySelector('.cc-countdown__label');
          if (label) label.textContent = expiredText;
        }
        clearInterval(this._interval);
        return;
      }

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = d;
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');

      const progress = this.querySelector('[data-progress]');
      if (progress) {
        const pct = Math.min(Math.max(((now - startDate) / (endDate - startDate)) * 100, 0), 100);
        progress.style.width = pct + '%';
      }
    };

    update();
    this._interval = setInterval(update, 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }



}
if (!customElements.get('concours-countdown')) customElements.define('concours-countdown', ConcoursCountdown);

/* --- Carousel --- */
class ConcoursCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = this.querySelectorAll('.cc-carousel__slide');
    this.thumbs = this.parentElement.querySelectorAll('.cc-carousel__thumb');
    this.dots = this.querySelectorAll('.cc-carousel__dot');
    this.track = this.querySelector('.cc-carousel__slides') || this.querySelector('.cc-carousel__track');
    this.current = 0;

    const prevBtn = this.querySelector('.cc-carousel__arrow--prev') || this.querySelector('.cc-carousel__btn--prev');
    const nextBtn = this.querySelector('.cc-carousel__arrow--next') || this.querySelector('.cc-carousel__btn--next');
    prevBtn?.addEventListener('click', () => this.go(this.current - 1));
    nextBtn?.addEventListener('click', () => this.go(this.current + 1));

    this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

        // Hide nav if 1 slide
    if (this.slides.length <= 1) {
      var _prev = this.querySelector('.cc-carousel__btn--prev') || this.querySelector('.cc-carousel__arrow--prev');
      var _next = this.querySelector('.cc-carousel__btn--next') || this.querySelector('.cc-carousel__arrow--next');
      var _dots = this.querySelector('.cc-carousel__dots');
      if (_prev) _prev.style.display = 'none';
      if (_next) _next.style.display = 'none';
      if (_dots) _dots.style.display = 'none';
    }

    // Touch support
    let startX = 0;
    this.track?.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.track?.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) this.go(this.current + (diff > 0 ? 1 : -1));
    }, { passive: true });

    // Auto-play
    if (this.getAttribute('data-autoplay') === 'true') { const speed = parseInt(this.getAttribute('data-autoplay-speed')) || 5000; this._autoplay = setInterval(() => this.go(this.current + 1), speed); }
  }

  go(idx) {
    const len = this.slides.length;
    if (len === 0) return;
    this.current = ((idx % len) + len) % len;
    if (this.track) this.track.style.transform = `translateX(-${this.current * this.clientWidth}px)`;
    this.thumbs.forEach((t, i) => t.classList.toggle('active', i === this.current));
    this.dots.forEach((d, i) => d.classList.toggle('active', i === this.current));
    clearInterval(this._autoplay);
    if (this.getAttribute('data-autoplay') === 'true') { const speed = parseInt(this.getAttribute('data-autoplay-speed')) || 5000; this._autoplay = setInterval(() => this.go(this.current + 1), speed); }
  }

  disconnectedCallback() {
    clearInterval(this._autoplay);
  }
}
if (!customElements.get('concours-carousel')) customElements.define('concours-carousel', ConcoursCarousel);

/* --- Pack Selector (Buy Box) --- */
class ConcoursBuyBox extends HTMLElement {
  connectedCallback() {
    this.packs = this.querySelectorAll('.cc-pack');
    this.selectedPack = null;

    // Pack click = accordion toggle
    this.packs.forEach(pack => {
      pack.addEventListener('click', (e) => {
        // Don't interfere with validate button
        if (e.target.closest('.cc-pack__validate-cta')) return;
        // Don't interfere with select dropdowns or expanded content
        if (e.target.closest('.cc-pack__expanded') && !e.target.closest('.cc-pack__name-row')) return;
        // Prevent anchor navigation on CHOISIR PACK buttons
        var anchor = e.target.closest('a');
        if (anchor) e.preventDefault();
        this.selectPack(pack);
      });
    });
  }

  selectPack(pack) {
    var wasSelected = pack.classList.contains('selected');

    // Close all packs
    this.packs.forEach(p => {
      p.classList.remove('selected');
      var exp = p.querySelector('.cc-pack__expanded');
      if (exp) exp.setAttribute('hidden', '');
      // Show the CHOISIR button
      var cta = p.querySelector('.cc-pack__cta-btn');
      if (cta) cta.style.display = '';
    });

    if (wasSelected) {
      this.selectedPack = null;
      return;
    }

    // Open this pack
    pack.classList.add('selected');
    this.selectedPack = pack;

    var expanded = pack.querySelector('.cc-pack__expanded');
    if (expanded) expanded.removeAttribute('hidden');

    // Hide the CHOISIR button when expanded
    var cta = pack.querySelector('.cc-pack__cta-btn');
    if (cta) cta.style.display = 'none';

    // Re-sync recap if size already selected
    var sizeSelect = pack.querySelector('.cc-pack__size-select');
    if (sizeSelect && sizeSelect.value) {
      sizeSelect.dispatchEvent(new Event('change'));
    }

    // Smooth scroll to card
    setTimeout(function() {
      pack.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 150);
  }
}
if (!customElements.get('concours-buybox')) customElements.define('concours-buybox', ConcoursBuyBox);

/* --- FAQ Accordion --- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cc-faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.cc-faq__item');
      const wasOpen = item.classList.contains('open');

      // Close all in same group
      item.closest('.cc-faq__questions')?.querySelectorAll('.cc-faq__item').forEach(i => {
        i.classList.remove('open');
        const icon = i.querySelector('.cc-faq__icon');
        if (icon) icon.textContent = '+';
        i.querySelector('.cc-faq__question')?.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('open');
        const icon = item.querySelector('.cc-faq__icon');
        if (icon) icon.textContent = '-';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href="#cc-cta"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.getElementById('cc-cta');
      if (target) {
        const offset = document.querySelector('.cc-header')?.offsetHeight || 60;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth'
        });
      }
    });
  });

  // Calculate totals on page load for all packs (not just on size change)
  function calculatePackTotal(pack) {
    // Use bundle price from data attribute if available (set by theme editor)
    var bundlePrice = pack.dataset ? pack.dataset.bundlePrice : null;
    if (bundlePrice && bundlePrice.trim()) {
      // Bundle price is pre-set from settings, use it directly for total and CTA
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = bundlePrice.trim();
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = bundlePrice.trim();
      return;
    }
    // Fallback: sum product prices only (shipping excluded)
    var total = 0;
    pack.querySelectorAll('.cc-pack__recap-lines .cc-pack__recap-line-price').forEach(function(el) {
      if (el.closest('.cc-pack__recap-line--bonus')) return;
      if (el.closest('.cc-pack__recap-line--shipping')) return;
      var text = el.textContent.trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
      var val = parseFloat(text);
      if (!isNaN(val)) total += val;
    });
    if (total > 0) {
      var formatted = total.toFixed(2).replace('.', ',') + ' \u20ac';
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = formatted;
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    }
  }

  // Run on load for all packs
  document.querySelectorAll('.cc-pack, .cc-cta-pack').forEach(calculatePackTotal);
});

/* --- Roadmap Scroll --- */
class ConcoursRoadmap extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.cc-roadmap__track');
    const prevBtn = this.querySelector('[data-roadmap-prev]');
    const nextBtn = this.querySelector('[data-roadmap-next]');

    const scrollDist = () => {
      const card = track?.querySelector('.cc-roadmap__card');
      return card ? card.offsetWidth + 20 : 360;
    };

    if (prevBtn && track) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollDist(), behavior: 'smooth' });
      });
    }
    if (nextBtn && track) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollDist(), behavior: 'smooth' });
      });
    }

    // Progress bar fill - driven by horizontal scroll of the track
    const fill = this.querySelector('.cc-roadmap__progress-fill');
    if (fill && track) {
      const minPct = 8;

      const updateFill = () => {
        const scrollable = track.scrollWidth - track.clientWidth;
        const ratio = scrollable > 0 ? track.scrollLeft / scrollable : 0;
        fill.style.width = (minPct + ratio * (100 - minPct)) + '%';
        fill.style.transition = 'none';
      };

      track.addEventListener('scroll', updateFill, { passive: true });
      updateFill();
    }
  }
}
customElements.define('concours-roadmap', ConcoursRoadmap);

/* --- Animated counter for progress --- */
function animateCounter(el, target, duration = 2000) {
  const start = 0;
  const startTime = performance.now();

  function update(time) {
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = Math.round(start + (target - start) * eased);
    el.textContent = current.toLocaleString('fr-FR');
    if (progress < 1) requestAnimationFrame(update);
  }

  requestAnimationFrame(update);
}

// Intersection Observer for counter animation
const counterObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      const target = parseInt(el.getAttribute('data-count-to') || el.getAttribute('data-target'), 10);
      if (target) animateCounter(el, target);
      counterObserver.unobserve(el);
    }
  });
}, { threshold: 0.5 });

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-count-to]').forEach(el => counterObserver.observe(el));
});



/* --- Prize Card Thumbnail Switcher --- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cc-prize-card__thumb[role="button"]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const card = thumb.closest('.cc-prize-card');
      if (!card) return;

      // Update active state
      card.querySelectorAll('.cc-prize-card__thumb').forEach(t => {
        t.classList.remove('cc-prize-card__thumb--active');
      });
      thumb.classList.add('cc-prize-card__thumb--active');

      // Swap main image if data-full-src exists
      const fullSrc = thumb.getAttribute('data-full-src');
      if (fullSrc) {
        const mainImg = card.querySelector('.cc-prize-card__img');
        if (mainImg) {
          mainImg.src = fullSrc;
        }
      }
    });
  });

  // Calculate totals on page load for all packs (not just on size change)
  function calculatePackTotal(pack) {
    // Use bundle price from data attribute if available (set by theme editor)
    var bundlePrice = pack.dataset ? pack.dataset.bundlePrice : null;
    if (bundlePrice && bundlePrice.trim()) {
      // Bundle price is pre-set from settings, use it directly for total and CTA
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = bundlePrice.trim();
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = bundlePrice.trim();
      return;
    }
    // Fallback: sum product prices only (shipping excluded)
    var total = 0;
    pack.querySelectorAll('.cc-pack__recap-lines .cc-pack__recap-line-price').forEach(function(el) {
      if (el.closest('.cc-pack__recap-line--bonus')) return;
      if (el.closest('.cc-pack__recap-line--shipping')) return;
      var text = el.textContent.trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
      var val = parseFloat(text);
      if (!isNaN(val)) total += val;
    });
    if (total > 0) {
      var formatted = total.toFixed(2).replace('.', ',') + ' \u20ac';
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = formatted;
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    }
  }

  // Run on load for all packs
  document.querySelectorAll('.cc-pack, .cc-cta-pack').forEach(calculatePackTotal);
});

/* --- CTA Pack Selection (bottom section) --- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cc-cta-pack').forEach(pack => {
    pack.style.cursor = 'pointer';
    pack.addEventListener('click', (e) => {
      // Don't intercept the CTA button click
      if (e.target.closest('.cc-pack__cta-btn')) return;

      // Toggle selection
      const wasSelected = pack.classList.contains('cc-cta-pack--selected');

      // Deselect all
      document.querySelectorAll('.cc-cta-pack').forEach(p => {
        p.classList.remove('cc-cta-pack--selected');
        const radio = p.querySelector('.cc-pack__radio');
        if (radio) radio.classList.remove('cc-pack__radio--active');
      });

      // Select this one (unless it was already selected)
      if (!wasSelected) {
        pack.classList.add('cc-cta-pack--selected');
        const radio = pack.querySelector('.cc-pack__radio');
        if (radio) radio.classList.add('cc-pack__radio--active');
      }
    });
  });

  // Calculate totals on page load for all packs (not just on size change)
  function calculatePackTotal(pack) {
    // Use bundle price from data attribute if available (set by theme editor)
    var bundlePrice = pack.dataset ? pack.dataset.bundlePrice : null;
    if (bundlePrice && bundlePrice.trim()) {
      // Bundle price is pre-set from settings, use it directly for total and CTA
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = bundlePrice.trim();
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = bundlePrice.trim();
      return;
    }
    // Fallback: sum product prices only (shipping excluded)
    var total = 0;
    pack.querySelectorAll('.cc-pack__recap-lines .cc-pack__recap-line-price').forEach(function(el) {
      if (el.closest('.cc-pack__recap-line--bonus')) return;
      if (el.closest('.cc-pack__recap-line--shipping')) return;
      var text = el.textContent.trim().replace(/[^0-9,.-]/g, '').replace(',', '.');
      var val = parseFloat(text);
      if (!isNaN(val)) total += val;
    });
    if (total > 0) {
      var formatted = total.toFixed(2).replace('.', ',') + ' \u20ac';
      var totalEl = pack.querySelector('[data-pack-total]') || pack.querySelector('.cc-pack__recap-total-amount');
      if (totalEl) totalEl.textContent = formatted;
      var ctaEl = pack.querySelector('[data-pack-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    }
  }

  // Run on load for all packs
  document.querySelectorAll('.cc-pack, .cc-cta-pack').forEach(calculatePackTotal);
});


// FAQ: click anywhere on item to toggle (not just the button)
document.addEventListener('click', function(e) {
  var item = e.target.closest('.cc-faq__item');
  if (!item) return;
  // Don't double-fire if they clicked the button itself
  if (e.target.closest('.cc-faq__question')) return;
  var btn = item.querySelector('.cc-faq__question');
  if (btn) btn.click();
});

// Reset any stale disabled validate buttons on load
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cc-pack__validate-cta').forEach(function(btn) {
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
  });
});
